import React from 'react';
import { MapPin } from 'lucide-react';
import { cityCoords } from '../data.js';
import { EmptyState } from './ui.jsx';

export default function LocationsMap({ accounts = [] }) {
  const withHq = accounts.filter((a) => a.hq && a.hq !== '—');
  const counts = {};
  withHq.forEach((a) => { const city = a.hq.split(',')[0].trim(); counts[city] = (counts[city] || 0) + 1; });
  const total = withHq.length;
  const ranked = Object.entries(counts).sort((a, b) => b[1] - a[1]).slice(0, 5);

  return (
    <div className="card">
      <div className="card-header"><div><div className="card-title">Top account locations</div><div className="card-subtitle">By headquarters city</div></div></div>
      <div className="card-body">
        {ranked.length === 0 ? (
          <EmptyState icon={MapPin} title="No location data yet" desc="Add a headquarters city to your accounts to see them mapped here." />
        ) : (
          <>
            <div className="map-wrap">
              <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%', display: 'block' }}>
                <path d="M35,8 C48,6 58,14 60,24 C64,30 62,38 66,44 C70,50 68,58 62,62 C60,70 56,76 50,82 C46,90 40,94 36,88 C30,84 32,76 28,70 C22,64 20,54 24,46 C20,38 22,28 28,20 C28,14 30,10 35,8 Z" fill="#D7E2FA" opacity="0.9" />
              </svg>
              {ranked.map(([city, count]) => {
                const c = cityCoords[city] || { x: 40, y: 50 };
                return <span key={city} className="map-marker" style={{ left: `${c.x}%`, top: `${c.y}%` }} title={city} />;
              })}
            </div>
            <div className="map-list">
              {ranked.map(([city, count], i) => (
                <div className="map-list-row" key={city}>
                  <span className="map-list-rank">{i + 1}.</span>
                  <span>🇮🇳</span>
                  <span className="map-list-name">{city}</span>
                  <span className="map-list-pct">{Math.round((count / total) * 100)}%</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
